const impacts = [
  {
    title: "Education",
    desc: "Quality computer education and skill development programs",
    img: "https://images.pexels.com/photos/10638115/pexels-photo-10638115.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Healthcare",
    desc: "Supporting community health initiatives and ASHA workers",
    img: "https://images.pexels.com/photos/25746822/pexels-photo-25746822.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Women Empowerment",
    desc: "Programs to build confidence and leadership in women",
    img: "https://images.pexels.com/photos/36739282/pexels-photo-36739282.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Community Development",
    desc: "Grassroots initiatives for rural and tea garden areas",
    img: "https://images.unsplash.com/photo-1759738101500-6d8d522b2681?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxydXJhbCUyMGNvbW11bml0eSUyMGRldmVsb3BtZW50JTIwaW5kaWF8ZW58MHx8fHwxNzc5Nzg3OTc1fDA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Impact() {
  return (
    <section className="py-24 bg-white" data-testid="impact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="overline text-[#E07A5F]">Our Footprint</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl text-[#1B4332] mt-3 leading-tight">
            Where We Make Impact
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {impacts.map((it, idx) => (
            <div
              key={it.title}
              className="group relative rounded-2xl overflow-hidden h-[380px] cursor-pointer"
              data-testid={`impact-card-${idx}`}
            >
              <img
                src={it.img}
                alt={it.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1f17] via-[#0f1f17]/40 to-transparent" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <h3 className="font-serif-display text-2xl text-white">{it.title}</h3>
                <p className="text-sm text-stone-200 mt-1 leading-relaxed">{it.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
